import type { ExploreContentItemContentOneOf } from './exploreContentItemContentOneOf';
import type { ExploreContentItemContentOneOfThreeseven } from './exploreContentItemContentOneOfThreeseven';
import type { ExploreContentItemContentOneOfFivezero } from './exploreContentItemContentOneOfFivezero';

/**
 * 콘텐츠 데이터 (타입에 따라 다른 형식)
 */
export type ExploreContentItemContent = ExploreContentItemContentOneOf | ExploreContentItemContentOneOfThreeseven | ExploreContentItemContentOneOfFivezero;
